import { render, staticRenderFns } from "./AgentTransactionsReports.vue?vue&type=template&id=1b1f1ecb"
import script from "./AgentTransactionsReports.vue?vue&type=script&lang=js"
export * from "./AgentTransactionsReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports